import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  FETCH_DASHBOARD_DATA_REMOVE
} from '../types/index';

interface Transaction {
  type: string;
  count: string;
  amount: string;
}

interface DashboardResponse {
  transactions: Transaction[];
}

interface DashboardDataState {
  data: DashboardResponse |any[] | null  ;
  dashLoading: boolean;
  error: any; // You can use a more specific type for error, like `string` or `Error`
}

const initialState: DashboardDataState = {
  data:[],
  dashLoading: false,
  error: null,
};

const dashboardDataReducer = (
  state = initialState,
  action: { type: any; payload: any; error: any }
) => {
  switch (action.type) {
    case FETCH_DASHBOARD_DATA_REQUEST:
      return { ...state, dashLoading: true, error: null };
    case FETCH_DASHBOARD_DATA_SUCCESS:
      return { ...state, dashLoading: false, data: action.payload, error: null };
    case FETCH_DASHBOARD_DATA_FAILURE:
      return { ...state, dashLoading: false, error: action.error, data: [] };
    case FETCH_DASHBOARD_DATA_REMOVE:
      return {
        data: [],
        dashLoading: false,
        error: null,
      }

    default:
      return state;
  }
};

export default dashboardDataReducer;
